import { GetAppointmentsByMonth } from 'domain/usecases/scheduling/get-appointments-by-month'
import { SchedulingRepository } from 'repository/interfaces/scheduling-repository'

export class RemoteGetAppointmentsByMonth implements GetAppointmentsByMonth {
  private readonly schedulingRepository: SchedulingRepository

  constructor(schedulingRepository: SchedulingRepository) {
    this.schedulingRepository = schedulingRepository
  }

  load(
    params: GetAppointmentsByMonth.Params
  ): Promise<GetAppointmentsByMonth.Model> {
    return this.schedulingRepository.getAppointmentsByMonth(params)
  }
}

export type SearchDoctorsModel = GetAppointmentsByMonth.Model
